/* eslint-disable jsx-a11y/alt-text */
import { useDeferredValue, useEffect, useMemo, useRef, useState } from "react";

import { useSharedData } from "bossjob-remote/dist/hooks";
import { selfJobFunctionOptionsKey } from "app/components/providers/configProvider";
import { Collapse, Drawer, Input, Modal } from "antd";
import { DownIcon, LeftIcon, SearchIcon } from "./assets";
import classNames from "classnames";

import styles from "./index.module.scss";
import { formatTemplateString } from "helpers/formatter";

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export const JobFunctionSingleSelectorFormMobile = (props: {
  value: {
    id: any;
    value: any;
  };
  lang: Record<string, any>;
  onChange: (selectItem?: any) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  text: {
    title: "Job Title";
    expandText: "Expand All";
    collapseText: "Collapse All";
    inputPlaceholder: "Enter a Job Title";
  };
}) => {
  //
  const { value: outerValue, onChange, lang, open, onOpenChange, text } = props;
  const config = useSharedData("CONFIG");
  const dic = useSharedData("DICTIONARY");

  const jobFunctions = (config && config[selfJobFunctionOptionsKey]) ?? [];
  const [activeKeys, setActiveKeys] = useState([]);
  const [value, setValue] = useState([]);

  const [inputValue, setInputValue] = useState("");
  const deferredValue = useDeferredValue(inputValue);
  const contentRef = useRef<HTMLDivElement>(null);

  let opts = useMemo<any[]>(() => {
    let convertedValue = jobFunctions.map((v) => {
      return {
        label: v.value,
        value: v.id,
        children: v.sub_function_list.map((v) => {
          return {
            label: v.value,
            value: v.id,
            children: v.job_titles.map((v) => {
              return {
                ...v,
                label: v.value,
                value: v.id
              };
            })
          };
        })
      };
    });
    return convertedValue;
  }, [jobFunctions]);

  const filteredOpt = useMemo(() => {
    let convertedValue = opts;

    if (deferredValue) {
      convertedValue = convertedValue
        .map((v) => {
          let mappedChild = v.children
            .map((subListItem) => {
              let children = subListItem.children
                .map((jobTitle) => {
                  let include = `${jobTitle.label}`
                    .toLocaleLowerCase()
                    .includes(deferredValue.toLocaleLowerCase());
                  if (include) {
                    return {
                      ...jobTitle,
                      originalLabel: jobTitle.label,
                      label: `${jobTitle.label}`.replaceAll(
                        new RegExp(escapeRegExp(deferredValue), "gi"),
                        `<span>$&</span>`
                      )
                    };
                  }
                  return null;
                })
                .filter(Boolean);
              return children?.length ? { ...subListItem, children } : null;
            })
            .filter(Boolean);

          return mappedChild.length
            ? {
                ...v,
                children: mappedChild
              }
            : null;
        })
        .filter(Boolean);
    }
    return convertedValue;
  }, [opts, deferredValue]);

  useEffect(() => {
    let result = {};
    let result1 = {};
    let result2 = {};

    opts.forEach((v) => {
      result[v.value] = v;
      if (v.children) {
        (v.children || []).forEach((v1) => {
          result1[v1.value] = v1;
          v1.p = v;
          (v1.children || []).forEach((v2) => {
            result2[v2.value] = v2;
            v2.p = v1;
          });
        });
      }
    });
    let key = outerValue.id || outerValue.value;
    if (key) {
      let target = result2[key];
      let newResult = [];
      while (target) {
        newResult.push(target.value);
        target = target.p;
      }
      setValue(
        [key]
        // newResult.reverse() as any
      );
    } else {
      setValue([] as any);
    }
  }, [opts, outerValue]);

  useEffect(() => {
    document.getElementById("checkedFunction")?.scrollIntoView?.({ block: "center" });
  }, [open]);

  let showFilterOpt = Boolean(filteredOpt.length && inputValue);

  const currentKeys = showFilterOpt
    ? filteredOpt.map((v, i) => {
        return `${i}`;
      })
    : activeKeys;

  let renderItems = showFilterOpt ? filteredOpt : opts;

  const items = renderItems.map((v, i) => {
    return {
      key: v.id,
      value: v.id,
      label: (
        <div className={styles.mainHeader}>
          {v.label}
          <span
            className={classNames(styles.iconWrapper, currentKeys.includes(`${i}`) && styles.open)}
          >
            <DownIcon />
          </span>
        </div>
      ),
      children: (
        <>
          {v.children.map((item) => {
            return (
              <div key={item.id}>
                <div className={styles.secondaryTitle}>{item.label}</div>
                <div className={styles.jobTitleWrapper}>
                  {item.children.map((jobTitle) => {
                    const hasChecked = value.includes(jobTitle.value);
                    // console.log("hasChecked", hasChecked, value, jobTitle.label, jobTitle.value);

                    return (
                      <div
                        key={jobTitle.id}
                        onClick={(e) => {
                          onChange({
                            value: jobTitle.value,
                            label: jobTitle.originalLabel || jobTitle.label
                          });
                          setValue([jobTitle.value]);

                          onOpenChange(false);
                        }}
                        id={hasChecked ? "checkedFunction" : ""}
                        className={classNames(styles.jobTitleItem, hasChecked && styles.checked)}
                        dangerouslySetInnerHTML={{ __html: jobTitle.label }}
                      ></div>
                    );
                  })}
                </div>
              </div>
            );
          })}
          <div style={{ height: 12 }}></div>
        </>
      ),
      showArrow: false
    };
  });

  const toggle = () => {
    onOpenChange(!open);
  };

  const emptyString =
    dic?.comm?.cascader?.resultNotFound ||
    "No matches found. {{add}} your custom job title instead.";

  let doesAllOpened = showFilterOpt ? false : currentKeys.length === Object.keys(opts).length;

  return (
    <>
      <Drawer
        zIndex={3000}
        open={open}
        onClose={toggle}
        styles={{ header: { display: "none" } }}
        height={"100%"}
        placement='bottom'
        afterOpenChange={(open) => {
          if (!open) {
            setInputValue("");
          }
        }}
        className={styles.drawerRoot}
      >
        <div className={styles.drawerContent}>
          <div className={styles.headerRoot}>
            <span className={styles.leftBackBtn} onClick={toggle}>
              <LeftIcon />
            </span>
            <div className={styles.title}>
              {text.title}
              {/* Job Title */}
            </div>
            <span
              className={styles.headerBtn}
              onClick={(e) => {
                if (showFilterOpt) {
                  return;
                }
                setActiveKeys(doesAllOpened ? [] : Object.keys(opts));
              }}
            >
              {doesAllOpened ? text.collapseText : text.expandText}
            </span>
          </div>

          <div className={styles.inputWrapper}>
            <Input
              prefix={<SearchIcon />}
              placeholder={text.inputPlaceholder}
              value={inputValue}
              onChange={(e) => {
                let value = e.target.value;
                setInputValue(value);
              }}
            />
          </div>

          {inputValue && !filteredOpt.length && (
            <div
              className={styles.addRow}
              onClick={(e) => {
                if ((e.target as HTMLSpanElement).className.includes("highlight")) {
                  onOpenChange(false);
                  onChange({
                    label: inputValue,
                    value: 881 // 881 is the if of other jobs
                  });
                }
              }}
              dangerouslySetInnerHTML={{
                __html: formatTemplateString(
                  emptyString,
                  `<span class="highlight">${dic?.profile?.add || "Add"}</span>`
                )
              }}
            ></div>
          )}

          <div ref={contentRef} style={{ position: "relative", flex: 1, overflow: "scroll" }}>
            <Collapse
              activeKey={currentKeys}
              onChange={
                showFilterOpt
                  ? null
                  : (newValue) => {
                      let lastOne = newValue[newValue.length - 1];

                      if (lastOne && lastOne === `${`${renderItems.length - 1}`}`) {
                        setTimeout(() => {
                          contentRef.current?.scrollTo?.({
                            top: contentRef.current.scrollTop + 200
                          });
                        }, 200);
                      }
                      setActiveKeys(newValue);
                    }
              }
              ghost
              items={items}
              className={styles.jobFunctionCollapse}
            />
          </div>
        </div>
      </Drawer>
    </>
  );
};
